import { render, staticRenderFns } from "./sub-list.vue?vue&type=template&id=d1333118&scoped=true"
import script from "./sub-list.vue?vue&type=script&lang=ts"
export * from "./sub-list.vue?vue&type=script&lang=ts"
import style0 from "./sub-list.vue?vue&type=style&index=0&id=d1333118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1333118",
  null
  
)

export default component.exports